import { render, staticRenderFns } from "./CardBook.vue?vue&type=template&id=13dbbef4&scoped=true"
import script from "./CardBook.vue?vue&type=script&lang=js"
export * from "./CardBook.vue?vue&type=script&lang=js"
import style0 from "./CardBook.vue?vue&type=style&index=0&id=13dbbef4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dbbef4",
  null
  
)

export default component.exports